import { ItemListResponse } from '@hl-itemlist/api/itemlist-api'
import { ProductCard, toProductCard } from './product-card'

/**
 * 商品一覧の読み込み状態。1ページ分のレスポンス反映で「ひとまとまり」で更新されるフィールド群を宣言し、
 * 個別代入による一部だけの更新・初期化忘れが書けないよう、操作(createInitialProductList / appendPage)が
 * 返す新しい状態への丸ごと差し替えでのみ変更する。
 * loading・取得エラー・価格は更新のタイミングが異なる(開始/終了・catch・非同期後着のマージ)ため含めない。
 */
export interface ProductListState {
  readonly products: ReadonlyArray<ProductCard>
  /** 取得済みの最終ページ番号。未取得は0(次に取得するのは currentPage + 1) */
  readonly currentPage: number
  readonly reachedLast: boolean
  /** 1ページ目の取得成功まではnull(件数を表示しない) */
  readonly totalItems: number | null
}

export function createInitialProductList(): ProductListState {
  return {
    products: [],
    currentPage: 0,
    reachedLast: false,
    totalItems: null,
  }
}

/**
 * 取得した1ページ分を一覧へ反映した新しい状態を返す。
 * 1ページ目/追加ページの区別は持たず常に末尾へ足す(一覧のリセットは呼び出し側が
 * createInitialProductListへの差し替えで行っている前提)。
 * 最終ページ判定は、ページ番号の到達に加えて空ページ(公開絞り込みで件数が減った等)でも打ち切る。
 */
export function appendPage(list: ProductListState, response: ItemListResponse): ProductListState {
  return {
    products: [...list.products, ...response.items.map(toProductCard)],
    currentPage: response.meta.currentPage,
    reachedLast: response.meta.currentPage >= response.meta.totalPages || response.items.length === 0,
    totalItems: response.meta.totalItems,
  }
}
